var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxReceiptOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2255 7.47704C10.1607 7.2936 10.0606 7.12678 9.93349 6.98473C9.66304 6.68258 9.27005 6.49243 8.83263 6.49243H7.68945C6.96134 6.49243 6.37109 7.08268 6.37109 7.81077C6.37109 8.43032 6.80248 8.96627 7.40772 9.09868L9.14824 9.47941C9.82627 9.62773 10.3095 10.2286 10.3095 10.9227C10.3095 11.7383 9.64831 12.4001 8.83263 12.4001H7.84801C7.20495 12.4001 6.65789 11.9891 6.45513 11.4155",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33984 6.4923V5.01538",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33984 13.8771V12.4001",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5392 2.80005H5.01617C4.42861 2.80005 3.86512 3.03346 3.44966 3.44892C3.03419 3.86439 2.80078 4.42788 2.80078 5.01543V17.2L5.57001 15.5385L8.33924 17.2L11.1085 15.5385L13.8777 17.2V4.46159C13.8777 4.02093 14.0527 3.5983 14.3643 3.2867C14.6759 2.9751 15.0986 2.80005 15.5392 2.80005ZM15.5392 2.80005C15.9799 2.80005 16.4026 2.9751 16.7142 3.2867C17.0258 3.5983 17.2008 4.02093 17.2008 4.46159V8.33851H13.8777",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxReceiptOutline);
export default __webpack_public_path__ + "static/media/icon_20px_receipt_outline.1278f7944effd3b5d02d42e1f51e68b0.svg";
export { ForwardRef as ReactComponent };